import { IncidentRequestPost, PearDetails } from './incidentRequestPost.model';
import { IncidentRequestGet } from './incidentRequestPost.model';

export class IncidentRequest {
  IncidentRequest: IncidentRequestPost = new IncidentRequestPost();
  IncidentRequest1:IncidentRequestGet =  new IncidentRequestGet();
  IncidentPEARList: IncidentPearDetails[];
  IncidentPotentialPEARList: PearDetails[];
}
export class IncidentPearDetails {
  Pear: String = '';
  Severity: number = 0;
}
